<h3 mat-dialog-title>{{ data.titleLabel | translate }}</h3>

<div mat-dialog-content>
    <div class="row no-gutters">
        <div class="col-12" *ngIf="data.descriptionLabel">
            {{ data.descriptionLabel | translate : data.descriptionValues }}
        </div>

        <div class="col-12" *ngIf="data.description">
            {{ data.description }}
        </div>

        <div class="col-12" *ngIf="data.descriptionHtml" [innerHTML]="data.descriptionHtml"></div>

        <div class="col-12" *ngFor="let error of (data.errors || [])">
            {{ error.description }}
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="onDismiss()" *ngIf="data.hasCancelLabel">
        {{ (data.cancelLabel || 'LABEL.CANCEL') | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">
        {{ (data.confirmLabel || 'LABEL.CONFIRM') | translate }}
    </button>
</div>

